import * as cookieConsent from './includes/cookie-consent-config';
import * as trackingTools from './includes/tracking-tools';
import * as utils from './includes/utils';

cookieConsent.enableCookieConsent();

// Only enable Google Analytics, if user has allowed cookies
const cookies = utils.getCookiesAsObject();
if (cookies.cookieconsent_status === 'allow') {
    if (!trackingTools.isGoogleAnalyticsLoaded()) {
        trackingTools.enableGoogleAnalytics();
    }
}
